import { makeStyles } from 'tss-react/mui';

const name = 'RequestsChart';

export const useRequestsChartStyles = makeStyles({ name })(theme => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    height: 300,
  },
}));
